import { object, string, number } from 'yup';
import { transactionStore, useStores } from '../../stores';
import { TransactionsController } from '../../controllers';
import { amountFormatter } from '../../utils/utils';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React from 'react';
import { observer } from 'mobx-react';
import UpdateTransactions from '../../pages/Transactions/UpdateTransactions';

const UpdateTransactionContainer = ({ closeModal }) => {
	const {
		appStore: { loading, setLoading },
	} = useStores();
	const transaction = transactionStore.selectedTransaction;
	const validationSchema = () => {
		return object({
			paidDate: string().test(function () {
				const { status, paidDate } = this.parent;
				return (status === constant.TRANSACTION_STATUS.PAID ||
					status === constant.TRANSACTION_STATUS.PARTIALLY_PAID) &&
					!paidDate
					? this.createError({
							message: `Payment date is required for a ${status} status`,
							path: 'paidDate',
					  })
					: true;
			}),

			amountPaid: number()
				.min(0)
				.test(function () {
					const { status, amountPaid } = this.parent;
					return (status === constant.TRANSACTION_STATUS.PARTIALLY_PAID) &&
						amountPaid === 0
						? this.createError({
								message: `Amount Paid is required for ${status} status`,
								path: 'amountPaid',
						  })
						: true;
				}),
			paymentMethod: string().test(function () {
				const { status, paymentMethod } = this.parent;
				return (status === constant.TRANSACTION_STATUS.PAID ||
					status === constant.TRANSACTION_STATUS.PARTIALLY_PAID) &&
					!paymentMethod
					? this.createError({
							message: `Payment method is required for a ${status} status`,
							path: 'paymentMethod',
					  })
					: true;
			}),
			status: string().required(' Status is required'),
		});
	};

	const balanceAmount = values =>
		amountFormatter(transaction.currencyCode).format(values.status === constant.TRANSACTION_STATUS.PAID ? 0
			: transaction.balanceAmount - values.amountPaid
		);

	const onSubmit = async payload => {
		setLoading(true);
		payload.transactionId = transaction._id;
		if(payload.status === constant.TRANSACTION_STATUS.PAID){
			payload.amountPaid = transaction.balanceAmount;
		}
		const { status, errorMessage } =
			await TransactionsController.updateOfflineTransactionBalance(payload);
		setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({ message: constant.Success });
		} else {
			MimaToastUtil.error({ message: errorMessage })
		}
		closeModal();
	};
	const onCloseModal = () => {
		closeModal();
		transactionStore.setSelectedTransaction({});
		setLoading(false);
	}

	return (
		<UpdateTransactions
			closeModal={onCloseModal}
			balanceAmount={balanceAmount}
			loading={loading}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
		/>
	);
};

export default observer(UpdateTransactionContainer);
